import Navbar from "./components/Navbar";
import Downpage from "./components/Downpage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import Apps from './pages/Apps';
import Contact from './pages/Contact';
import ScrollToTop from "./components/ScrollToTop";
import ScrollButton from "./components/ScrollButton";
import Privacypolicy from "./policyPages/Privacypolicy";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollButton />
      <div className="app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
        </Routes>
        <Downpage />
      </div>
    </BrowserRouter>
  );
}

export default App;
